import React, { useState, useEffect, useRef } from 'react'
import { Table, Button, Form, Input, message, Modal, TreeSelect } from "antd"
import { ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import BaseModal from '../../components/modal/BaseModal'
import FileBoxModal from '../../components/fileBox/FileBoxModal'
import { productCateList, productCateHandle, productCateDel } from "../../api"
import { nanoid } from 'nanoid';
import { useLangContext } from '../../utils/context'
const { confirm } = Modal;
function ProductCate(props) {
    const { langConfig } = useLangContext();
    const [modalConfig, setModalConfig] = useState({ visible: false, width: 920, title: '' })
    const [modalData, setModalData] = useState([])
    const [tableData, setTableData] = useState([])
    const [cateData, setCateData] = useState([])
    const [loading, setLoading] = useState(true)

    const fileboxRef = useRef(0);

    const getData = (type = "") => {
        setLoading(true)
        productCateList({ type }).then(res => {
            if (res.code === 200) {
                if (type === 1) {
                    setTableData(res.data)
                } else {
                    setCateData([{ value: 0, title: langConfig.article_as_root }, ...res.data])
                }
                setLoading(false)
            }
        }).catch(err => {
            console.log(err)
            setLoading(false)
        })
    }
    useEffect(() => {
        getData(1);
        getData();
    }, [])

    // 表格模块
    const tableColumns = [
        {
            title: langConfig.g_category,
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: langConfig.g_thumb,
            dataIndex: 'thumb',
            width: '130px',
            render: (text, record) => {
                return record.file_path ? <a href={record.file_path} target="_blank" rel="noreferrer"><img src={record.file_path} alt="" style={{ width: "40px", height: "40px", borderRadius: '5px', border: "#efe8e8 solid 1px" }} /></a> : ''
            },
        },
        {
            title: langConfig.g_sort+' (desc)',
            dataIndex: 'sort',
            key: 'sort',
            width: '130px',
        },
        // {
        //     title: '外部链接',
        //     dataIndex: 'jump_url',
        //     key: 'jump_url',
        //     width: '220px',
        // },
        {
            title: langConfig.g_create_at,
            dataIndex: 'created_at',
            key: 'created_at',
            width: 180
        },
        {
            title: langConfig.g_manage,
            key: 'Manage',
            width: '125px',
            render: (text, record) => {
                return <div>
                    <Button type='link' size='small' onClick={() => showEdit(record)}>{langConfig.g_edit}</Button>
                    <Button type='link' size='small' onClick={() => delData(record.id)}>{langConfig.g_del}</Button>
                </div>
            },
        },
    ]
    const showAdd = () => {
        form.resetFields();
        setModalData([]);
        setThumbData([])
        setModalConfig({ ...modalConfig, visible: true, title: langConfig.g_add })
    }
    const showEdit = (row) => {
        form.resetFields();
        form.setFieldsValue({ ...row })
        setModalData(row);
        if (row.thumb) {
            setThumbData([row.thumb])
        } else {
            setThumbData([])
        }
        setModalConfig({ ...modalConfig, visible: true, title: langConfig.g_edit })
    }

    const delData = (id) => {
        confirm({
            title: langConfig.g_reminder,
			icon: <ExclamationCircleOutlined />,
			content: langConfig.g_comfirm_del,
			cancelText: langConfig.g_cancel,
			okText: langConfig.g_ok,
            onOk() {
                productCateDel({ id: id }).then(res => {
                    getData(1);
                    getData();
                    // message.success("数据已删除！")
                    message.success(langConfig.g_del_succ)
                }).catch(err => {
                    console.log(err)
                })

            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    // 弹出层
    const [form] = Form.useForm();
    const onFinish = (values) => {
        let thumb_id = "";
        if (thumbData.length > 0) {
            thumb_id = thumbData[0].id;
        }
        productCateHandle({ ...values, thumb_id, id: modalData.id || "" }).then(res => {
            setModalConfig({ ...modalConfig, visible: false })
            getData(1);
            getData();
            message.info(res.msg)
        }).catch(err => {
            console.log(err)
        })

    };
    const layout = {
        labelCol: {
            span: 5,
        },
        wrapperCol: {
            span: 19,
        },
    };
    const modalHandle = (data) => {
        setModalConfig({ ...modalConfig, visible: false })
    }

    // 文件管理配置
    const [fileBoxConfig, setFileBoxConfig] = useState({ visible: false, max_select_count: 1, width: 1000, fileboxKey: nanoid() })
    const fileBoxHanlde = (obj) => {
        if (obj.type === 'ok') {
            setThumbData(obj.data)
        }
        setFileBoxConfig({ ...fileBoxConfig, visible: false });
    }
    const showUploadThumbBox = (field) => {
        setFileBoxConfig({ ...fileBoxConfig, visible: true, fileboxKey: nanoid() });
    }
    const handleDelThumb = (obj) => {
        setThumbData(thumbData.filter((item => item !== obj)))
    }
    const [thumbData, setThumbData] = useState([])
    const uploadThumbCom = () => {
        if (thumbData.length < fileBoxConfig.max_select_count) {
            let tmp = thumbData.map((item, index) => {
                return <li key={item.id}><a href={item.file_path} target="_blank" rel="noreferrer"><img src={item.file_path} alt="" /></a><div className='action-box' onClick={() => { handleDelThumb(item) }}>删除</div></li>
            })
            return (<>{tmp}<li className='my-upload-box' onClick={() => { showUploadThumbBox() }}><PlusOutlined /></li></>)
        } else {
            return thumbData.map((item, index) => {
                return <li key={item.id}><a href={item.file_path} target="_blank" rel="noreferrer"><img src={item.file_path} alt="" /></a><div className='action-box' onClick={() => { handleDelThumb(item) }}>删除</div></li>
            })
        }
    }

    return (
        <div>
            <div className='breaccrumb-box'>
                <div className='breaccrumb-left'><span>{langConfig.pro_bread_one} / </span>{langConfig.pro_cate}</div>
                <div className='breaccrumb-right'><Button type="primary" size='small' onClick={() => showAdd()}> <PlusOutlined />{langConfig.g_add}</Button></div>
            </div>

            <Table size='small' rowKey='id' columns={tableColumns} dataSource={tableData} pagination={false} loading={loading} />

            <BaseModal config={modalConfig} data={modalData} handle={modalHandle}>
                {/* <Form {...layout} form={form} onFinish={onFinish} layout="inline" className="my-inline-form">
                    <Form.Item name="title" label="分类名称"
                        rules={[
                            {
                                required: true,
                                message: '请填写分类名称'
                            },
                        ]}
                    >
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item name="parent_id" label="父级分类"
                        rules={[
                            {
                                required: true,
                                message: '请选择父级分类'
                            },
                        ]}
                    >
                        <TreeSelect allowClear treeData={cateData} />
                    </Form.Item>
                    <Form.Item name="jump_url" label="外部链接">
                        <Input allowClear placeholder='http(s)://开头' />
                    </Form.Item>
                    <Form.Item name="thumb_id" label="缩略图">
                        <div className='myupload-box-list'>
                            {uploadThumbCom()}
                        </div>
                    </Form.Item>
                    <Form.Item name="sort" label="排序" tooltip="降序，越大越靠前">
                        <Input allowClear />
                    </Form.Item>
                    <div style={{ marginTop: '10px', textAlign: "right", width: "100%", paddingRight: "13px" }}>
                        <Button type="primary" htmlType="submit">保存</Button>
                    </div>
                </Form> */}

                <Form {...layout} form={form} onFinish={onFinish} layout="inline" className="my-inline-form">
                    <Form.Item name="title" label={langConfig.g_category}
                        rules={[
                            {
                                required: true,
                                message: ''
                            },
                        ]}
                    >
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item name="parent_id" label={langConfig.g_parent}
                        rules={[
                            {
                                required: true,
                                message: ''
                            },
                        ]}
                    >
                        <TreeSelect allowClear treeData={cateData} />
                    </Form.Item>
                    <Form.Item name="seo_keyword" label={langConfig.g_keyword}>
                        <Input.TextArea allowClear />
                    </Form.Item>
                    <Form.Item name="seo_desc" label={langConfig.g_desc}>
                        <Input.TextArea allowClear />
                    </Form.Item>
                    <div style={{ height: '75px' }}></div>
                    <Form.Item name="thumb_id" label={langConfig.g_thumb}>
                        <div className='myupload-box-list'>
                            {uploadThumbCom()}
                        </div>
                    </Form.Item>
                    <Form.Item name="sort" label={langConfig.g_sort} tooltip="降序，越大越靠前">
                        <Input allowClear />
                    </Form.Item>
                    <div style={{ marginTop: '10px', textAlign: "right", width: "100%", paddingRight: "13px" }}>
                        <Button type="primary" htmlType="submit">{langConfig.g_save}</Button>
                    </div>
                </Form>
            </BaseModal>

            <FileBoxModal config={fileBoxConfig} handle={fileBoxHanlde}></FileBoxModal>

        </div>
    )
}

export default ProductCate